<template>
  <div class="custom-wrapper">
    <slot />
    <div class="container mt-5">
      <hr />
      <pre class="text-right text-muted">v{{version}}</pre>
    </div>
  </div>
</template>

<script>
export default {
  name: 'layout-no-nav',
  data() {
    return {
      version: window.config ? window.config.version : ''
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  width: 100%;
  min-height: calc(100vh - 105px);
  margin: 0 auto -80px;
  padding: 25px;
}
</style>



// WEBPACK FOOTER //
// src/layouts/no-nav.vue